import React from 'react'
import { BottomSheet, useToast } from 'shared-ui/components'
import { useReportReasons, usePostContentReport } from 'shared-ui/hooks'
import { ETERNAL_CONFIG, SUPER_APP_CONFIG,REPORT_TEXT } from 'shared-ui/utils/constants'
import { useTheme } from 'styled-components'
import {RadioInput} from './style'

const ReportSheet = ({
  open,
  onClose,
  reportReason,
  setReportReason,
  reportText,
  setReportText,
  contentData,
  user,
  setReportedIds
}) => {
  const theme =useTheme();
  const { showSuccess } = useToast()
  const { data, isLoading, isError } = useReportReasons({
    enabled: !!open
  })

  const { mutate: postReport, isLoading: isSubmitLoading } =
    usePostContentReport({
      onSuccess: (resp,variables) => {
        setReportedIds((prev) => [...prev, variables.content_id]);
        showSuccess(REPORT_TEXT.REPORT_SUCCESS_MESSAGE)
        setReportReason('')
        setReportText('')
        onClose()
      },
      onError: (error) => {
        console.error('Report failed:', error)
      }
    })

  const reportReasons = data?.reasons || []
  const isOtherSelected = reportReason?.value === 'other_reason'

  const isDisabled =
    !reportReason ||
    isSubmitLoading ||
    !contentData ||
    (isOtherSelected && !reportText.trim())

  const handleSubmit = () => {
    const contentId =
      contentData?.content_id || contentData?.id || contentData?._id || null
    if (!contentId) {
      console.error('Report failed: missing content id')
      return
    }

    postReport({
      content_id: contentId,
      reason_for_report: reportReason?.value || reportReason || '',
      reason: reportText || ''
    })
  }

  
  return (
    <BottomSheet open={open} onClose={onClose}>
      <div className="flex flex-col gap-3 py-7">
        <div className="text-xl text-left font-normal mb-1" style={{color:theme.app.text}}>
          {ETERNAL_CONFIG.REPORT}
        </div>
        <div className="text-sm font-normal text-left mb-4"  style={{color:theme.app.iconlabel}}>
          {SUPER_APP_CONFIG.DISCOVER_REPORT_SHEET_REASON_LABEL}
        </div>
        {!isLoading && !isError && (
          <div className="flex flex-col px-4 gap-3 mb-2">
            {reportReasons.length > 0 ? (
              reportReasons.map((reason, index) => (
                <label
                  key={reason?.id || reason?.value || (typeof reason === 'string' ? reason : index)}
                  className="flex items-center text-sm font-normal gap-3"
                  style={{color:theme.app.text}}
                >
                  <RadioInput
                    type="radio"
                    name="reportReason"
                    value={reason?.value || reason}
                    checked={reportReason === reason}
                    onChange={() => setReportReason(reason)}
                    className="appearance-none w-5 h-5 border-2  rounded-full checked:bg-white checked:ring-2 checked:ring-gray-500 focus:outline-none"
                  />
                  {reason?.label || reason}
                </label>
              ))
            ) : (
              <div className="text-sm" style={{color:theme.app.iconlabel}}>{SUPER_APP_CONFIG.DISCOVER_REPORT_SHEET_NO_REASONS}</div>
            )}
          </div>
        )}

        <textarea
        style={{color:theme.app.text}}
          className="w-full rounded border border-gray-600 bg-transparent p-3 mt-2 mb-4 placeholder:text-gray-400 focus:outline-none focus:ring-0 focus:border-2 focus:border-[#00bfff] transition-colors"
          rows={3}
          placeholder={SUPER_APP_CONFIG.DISCOVER_REPORT_SHEET_ADDITIONAL_INFO_PLACEHOLDER}
          value={reportText}
          autoComplete="off"
          onChange={(e) => setReportText(e.target.value)}
          maxLength={140}
        />
        <button
          className="w-full h-10 flex justify-center items-center rounded-full bg-[#007b8f] text-white font-semibold text-lg disabled:opacity-50"
          disabled={isDisabled}
          onClick={handleSubmit}
        >
          {isSubmitLoading ? `${SUPER_APP_CONFIG.DISCOVER_REPORT_SHEET_SUBMITTING}` : `${SUPER_APP_CONFIG.DISCOVER_REPORT_SHEET_SUBMIT}`}
        </button>
      </div>
    </BottomSheet>
  )
}

export default ReportSheet
